/* Guided breathing: inhale / hold / exhale with an expanding circle. */
import { useEffect, useRef, useState } from 'react';
import { Btn } from '../../ui/Button';

const STEP_TEXT = ['Burnundan nefes al', 'Tut', '"sss" diye yavaşça ver'] as const;
const STEP_SCALE = [1, null, 0.55] as const;

export function BreathWidget({ pattern, rounds }: { pattern: [number, number, number]; rounds: number }) {
  const [inh, hold, exh] = pattern;
  const [running, setRunning] = useState(false);
  const [label, setLabel] = useState('Hazır');
  const [count, setCount] = useState('');
  const [roundTxt, setRoundTxt] = useState(`${rounds} tur`);
  const [circle, setCircle] = useState({ scale: 0.55, dur: 0.6 });
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined);
  const live = useRef(false);

  const stop = (doneText?: string) => {
    live.current = false;
    clearTimeout(timer.current);
    setRunning(false);
    setCircle({ scale: 0.55, dur: 0.6 });
    setLabel(doneText ?? 'Hazır');
    setCount('');
  };

  const phase = (r: number, p: number) => {
    if (!live.current) return;
    if (r >= rounds) {
      stop('Bitti. Harika!');
      return;
    }
    setRoundTxt(`${r + 1}. tur / ${rounds}`);
    const sec = pattern[p] as number;
    const nextPhase = () => phase(p === 2 ? r + 1 : r, (p + 1) % 3);
    if (sec <= 0) {
      nextPhase();
      return;
    }
    setLabel(STEP_TEXT[p] as string);
    const scale = STEP_SCALE[p];
    if (scale != null) setCircle({ scale, dur: sec });
    let left = sec;
    setCount(String(left));
    const tick = () => {
      if (!live.current) return;
      left--;
      if (left <= 0) {
        nextPhase();
        return;
      }
      setCount(String(left));
      timer.current = setTimeout(tick, 1000);
    };
    timer.current = setTimeout(tick, 1000);
  };

  useEffect(
    () => () => {
      live.current = false;
      clearTimeout(timer.current);
    },
    [],
  );

  return (
    <div className="breath">
      <div className="br-stage">
        <div
          className="br-circle"
          style={{ transform: `scale(${circle.scale})`, transitionDuration: `${circle.dur}s` }}
        />
        <div className="br-text">
          <div className="br-label">{label}</div>
          <div className="br-count">{count}</div>
        </div>
      </div>
      <div className="br-foot">
        <div className="br-round">{roundTxt}</div>
        <span className="br-pattern">
          {inh} sn al · {hold} sn tut · {exh} sn ver
        </span>
        <Btn
          kind="primary"
          icon={running ? 'stop' : 'play'}
          onClick={() => {
            if (running) {
              stop();
              return;
            }
            live.current = true;
            setRunning(true);
            phase(0, 0);
          }}
        >
          {running ? 'Durdur' : 'Başlat'}
        </Btn>
      </div>
    </div>
  );
}
